/** Чьи данные показывает система: свои, данные владельца, открывшего зоны, или страницу по ссылке */
export enum EnumViewMode {
  OWNER = 'owner',
  VIEWER = 'viewer',
  GUEST = 'guest',
}
